import axios from 'axios'
import qs from 'qs'

export const goodList = (data) => {
    return axios({
        url: '/mall/phone/good/list/' ,
        method: 'get',
        params: data
    })
}

export const goodBanner= (data) => {
    return axios({
        url: '/mall/phone/good/banner/' ,
        method: 'get',
        params: data
    })
}

// 商品详情goodId
export const goodDetail= (data) => {
    return axios({
        url: '/mall/phone/good/detail/' ,
        method: 'get',
        params: data
    })
}

// 手机网页支付goodId
// {
//     "money": 0,
//     "cellId": 0,
//     "deviceCode": "string",
//     "goodId": 0,
//     "skuId": 0
//   }
export const alipayPhone= (data) => {
    return axios({
        url: '/mall/phone/alipay/phone/' ,
        method: 'post',
        data
    })
}

// 支付成功回调 查询订单payType  支付微信   orderNo订单号
export const queryOrderl= (data) => {
    return axios({
        url: '/mall/phone/query/order/' ,
        method: 'get',
        params: data
    })
}
// 微信网页支付
export const wechatPhone = (data) => {
  return axios({
    url: '/mall/phone/wechat/phone/',
    method: 'post',
    data
  })
}
// 余额支付
export const moneyPhone = (data) => {
    return axios({
      url: '/mall/phone/money/phone/',
      method: 'post',
      data
    })
  }
// 充值支付成功查询
export const rechargeQueryOrderl= (data) => {
    return axios({
        url: '/mall/phone/recharge/query/order/' ,
        method: 'get',
        params: data
    })
}
//获取商品详情
// export const goodDetailByGoodId= (data) => {
//     return axios({
//         url: '/mall/phone/good/detail/byGoodId/' ,
//         method: 'get',
//         params: data
//     })
// }

export const goodDetailByGoodId= (data) => {
  return axios({
      url: '/mall/phone/good/detail/' ,
      method: 'get',
      params: data
  })
}
